<template>
  <b-container class="user-login font_Montserrat v3_color_black_knight">
    <div class="my-5">
      <b-row align-h="center" align-v="center">
        <b-col sm="12" lg="6">
          <b-card no-body class="max_width_400 w-100 m-auto v3_box_teal">
            <b-card-header class="user-login__card-header v3_box_teal_header">
              Existing Users – Sign In
            </b-card-header>
            <b-card-body class="user-login__card-body v3_box_teal_body">
              <form @submit.prevent="signIn">
                <b-form-group
                  :state="validateState('login.email')"
                  :invalid-feedback="invalidFeedback.loginEmail"
                >
                  <div class="icon-input">
                    <span class="icon-input__icon">
                      <i
                        class="mdi mdi-email v3_color_teal"
                        aria-hidden="true"
                      />
                    </span>
                    <b-form-input
                      type="text"
                      v-model.trim="$v.login.email.$model"
                      class="pl-5 p-3 rounded_0 border_grey form-control height_auto"
                      placeholder="Email or Username"
                      :state="validateState('login.email')"
                    />
                  </div>
                </b-form-group>
                <b-form-group
                  :state="validateState('login.password')"
                  :invalid-feedback="invalidFeedback.required"
                >
                  <div class="icon-input">
                    <span class="icon-input__icon">
                      <i class="mdi mdi-lock" aria-hidden="true" />
                    </span>
                    <b-form-input
                      type="password"
                      class="pl-5 p-3 rounded_0 border_grey form-control height_auto"
                      v-model="$v.login.password.$model"
                      placeholder="Password"
                      :state="validateState('login.password')"
                    />
                  </div>
                </b-form-group>
                <div class="d-flex align-items-center justify-content-center">
                  <b-btn
                    variant="v3_teal_outline"
                    type="submit"
                    :disabled="loginLoading"
                  >
                    <b-spinner v-if="loginLoading" small />
                    <span v-else>Sign In</span>
                  </b-btn>
                </div>
              </form>
              <b-col cols="12" class="d-flex justify-content-center mt-2">
                <password-reset-request />
              </b-col>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import Api from '@/providers/Api.js';
import PasswordResetRequest from './password/reset/RequestForm';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import {
  AUTH_ACTION,
  //COOKIES,
  GET_USER_QUESTIONNAIRE_ACTION,
  SET_PASSWORD_RESET_REQUIRED_MUTATION,
} from '@/store';
import get from 'lodash/get';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
//import RegistrationHelpText from '@/components/auth/RegistrationHelpText';

export default {
  name: 'userLogin',
  mixins: [validationMixin],
  components: {
    PasswordResetRequest,
  },
  data: function () {
    return {
      login: {
        email: '',
        password: '',
      },
      registration: {
        email: '',
        token: '',
      },
      loginLoading: false,
      registrationLoading: false,
      needTokenLoading: false,
      isRegistrationTokenVisible: false,
      jobStorageData:[],
    };
  },
  created:function(){
    const storedData = localStorage.getItem('job_offer_signup_data');
    this.jobStorageData = storedData ? JSON.parse(storedData) : [];
    //console.log(JSON.stringify(this.jobStorageData));
  },
  validations: {
    login: {
      email: {
        required,
      },
      password: {
        required,
      },
    },
    registration: {
      email: {
        required,
        email,
      },
      token: {
        required,
      },
    },
  },
  computed: {
    invalidFeedback: function () {
      return {
        loginEmail: !this.$v.login.email ? 'This field is required' : '',
        registrationEmail: !this.$v.registration.email.email
          ? 'Please enter a valid Email address.'
          : 'This field is required',
        required: 'This field is required',
      };
    },
  },
  methods: {
    validateState: function (name) {
      const { $dirty, $error } = get(this.$v, name);
      return $dirty ? !$error : null;
    },
    signIn: async function () {
      this.$v.login.$touch();

      if (this.$v.login.$anyError) {
        return;
      }

      this.loginLoading = true;
      try {
        const { user, token } = await Api.signInUser(
          this.login.email,
          this.login.password
        );
        if (!user || !token) {
          return this.$toasted.show('Login failed, please try again');
        }
        if (user.is_password_reset_required === 1) {
          this.$store.commit(SET_PASSWORD_RESET_REQUIRED_MUTATION, true);
          await this.$store.dispatch(AUTH_ACTION, {
            user: null,
            token,
          });
          return this.$router.push('/auth/update-temporary-password');
        }
        await this.$store.dispatch(AUTH_ACTION, {
          user,
          token,
        });
        // if (
        //   this.$store.getters.userIsMSSRecruiter &&
        //   this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)
        // ) {
        //   if(user.roles[0]=='MSS_RECRUITER')
        //   {
        //     if(this.jobStorageData.length > 0)
        //     {
        //       this.$router.push('/recruiter/ico');
        //     }else{
        //       this.$router.push('/recruiter');
        //     } 
        //   }else{
        //     this.$router.push('/');
        //   }
        //   //this.$router.push('/recruiter/ico');
        // } else {
        //   if(user.roles[0]=='MSS_RECRUITER')
        //   {
        //     if(this.jobStorageData.length > 0)
        //     {
        //       this.$router.push('/recruiter/ico');
        //     }else{
        //       this.$router.push('/recruiter');
        //     } 
        //   }else{
        //     this.$router.push('/');
        //   }
        // }

        if(user.roles[0]=='MSS_RECRUITER')
        {
          if(this.jobStorageData.length > 0)
          {
            this.$router.push('/recruiter/ico');
          }else{
            this.$router.push('/recruiter');
          } 
        }else{
          this.$router.push('/');
        }

        await this.$store.dispatch(GET_USER_QUESTIONNAIRE_ACTION);
        localStorage.setItem('IS_INFORM_POPUP_SHOW', 1);
      } catch (error) {
        const message =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
            ? error.response.data.message
            : 'Some error occurs';
        this.$toasted.show(message, {
          type: 'error',
          duration: 6000,
          action: {
            icon: 'mdi mdi-close-circle toaster-close-icon',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
      } finally {
        this.loginLoading = false;
      }
    },
    onRegisterHandler: async function () {
      this.$v.registration.$touch();

      if (this.$v.registration.$anyError) {
        return;
      }

      this.registrationLoading = true;
      try {
        const response = await Api.validateEmailAndToken(
          this.registration.email,
          this.registration.token
        );

        if (response) {
          this.$router.push(`/registration/${this.registration.token}`);
        }
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted, {
          duration: 6000,
        });
      } finally {
        this.registrationLoading = false;
      }
    },
    onNeedTokenHandler: async function () {
      this.$v.registration.email.$touch();

      if (this.$v.registration.email.$anyError) {
        return;
      }

      this.needTokenLoading = true;
      try {
        await Api.sendRegistrationToken(this.registration.email);
        this.isRegistrationTokenVisible = true;
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted, {
          duration: 6000,
        });
      } finally {
        this.needTokenLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/v3';

.invalid-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  display: block;
}

.user-login__card-header {
  padding: 10px 20px;
}

.user-login__card-body {
  padding: 15px 20px;

  i.mdi {
    @extend .font_size_1250rem;
    color: $v3_color_teal;
  }

  input {
    @include phairify_body_copy;
    @extend .border_grey;
    outline-color: $v3_color_grey;

    &:focus {
      border-color: $v3_color_grey;
      box-shadow: 0 0 0 0.2rem rgba($v3_color_grey, 0.25) !important;
      outline-color: $v3_color_grey;
    }
  }

  .btn.btn-primary {
    @include phairify_primary_button_enabled;
  }
}
</style>
